import React, { useState } from 'react';
import './menu.css';

function MenuModal({ isOpen, onClose, onLogout, onViewOrders }) {
  if (!isOpen) return null;


  

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-button" onClick={onClose}>
          X
        </button>
        <h2>Menu</h2>
        <ul>
          <li>
            <button onClick={onViewOrders}>View Previous Orders</button>
          </li>
          <li>
            <button onClick={onLogout}>Logout</button>
          </li>
        </ul>
      </div>
    </div>
  );
}


export default MenuModal;
